import React, { useState } from "react";

import DescriptionBox from "pages/details/components/description-box";
import DetailList from "pages/details/components/detail-list";
import TagsList from "pages/details/components/tags-list";
import MediaGallery from "pages/details/components/media-gallery";
import AppHeader from "pages/details/components/app-header";
import { useQuery } from "react-query";
import { AddonModule, AppDetailService } from "pages/details/app-detail.service";
import { json } from "helpers/data";
import Reviews from "pages/details/components/reviews";
import { useParams } from "react-router-dom";
import ModuleDialog from "pages/details/components/module-dialog";
import RelatedApps from "pages/details/components/related-apps";
import { useTranslation } from "react-i18next";

function AppDetailPage() {
  const { t } = useTranslation("details");
  const params = useParams();
  const appId = +params.id!;
  const [versionId, setVersionId] = useState<number | undefined>();
  const [selectedModule, setSelectedModule] = useState<null | AddonModule>(null);
  const { data: app } = useQuery(["app-details", appId], () => AppDetailService.getAppDetail(appId).then((r) => r.response));
  const { data: version } = useQuery(
    ["app-versions", appId, versionId],
    () => AppDetailService.getVersionDetail(appId, versionId).then((r) => r.response),
    { onSuccess: (v) => {setVersionId(v?.id)} }
  );

  return (
    <div className="addonDetails appDetails">
      <AppHeader
        isLiked={app?.isInWishlist}
        appId={appId}
        versionId={versionId}
        onVersionChange={setVersionId}
        logo={app?.logo?.fullPath}
        title={app?.title ?? ""}
        label={app?.label}
        price={version?.price}
        numberOfDownloads={version?.downloadCount}
        rating={app?.rate?.averageRate ?? 0}
        numberOfRates={app?.rate?.count ?? 0}
      />
      <div className="row">
        <div className="col-xl-6">
          <div className="all-content">
            <DescriptionBox content={json(app?.description ?? "")} />
            <DetailList
              items={version?.modules ?? []}
              title={t("appDetails.integratedModules")}
              labelField="title"
              onItemClick={setSelectedModule}
            />
            <DetailList items={version?.addons ?? []} title={t("appDetails.availableAddons")} labelField="title" />
            <TagsList tags={app?.tags ?? []} />
            <Reviews appId={appId} rate={app?.rate} />
            <RelatedApps apps={app?.relatedApps ?? []} />
          </div>
        </div>
        <div className="col-xl-6">
          <MediaGallery
            images={
              app?.slidersPath.map((slider) => ({
                original: slider,
                thumbnail: slider
              })) ?? []
            }
          />
        </div>
      </div>
      {selectedModule && <ModuleDialog onHide={() => setSelectedModule(null)} module={selectedModule} />}
    </div>
  );
}

export default AppDetailPage;
